<template>
  <v-container class="pa-0">
    <div class="d-flex align-center gap-1">
      <v-card-text class="pa-0 text-body-1 numpad-title">
        {{ $t("enter") }}
      </v-card-text>
      <v-card-text class="pa-0 text-body-2 numpad-title"> ({{ label }}) </v-card-text>
    </div>
    <div class="numpad-box mt-2">
      <div class="input-numpad">
        <span class="input-numpad-value">
          {{
            needSeperator
              ? value && value.charAt(value.length - 1) === "."
                ? $numberFormat(value, "plain", 0) + ".0"
                : $numberFormat(value, "plain", 0)
              : value
          }}
        </span>
      </div>
      <div class="numpad-keypad">
        <v-btn
          v-for="n in 9"
          :key="n"
          class="key key-light"
          depressed
          @click="clickNum(n)"
        >
          {{ n }}
        </v-btn>
        <v-btn class="key key-light" depressed @click="clickNum(0)">0</v-btn>
        <v-btn class="key key-light key-small" depressed @click="clickNum(10)">00</v-btn>
        <v-btn class="key key-light key-small" depressed @click="clickNum(100)"
          >000</v-btn
        >
        <v-btn class="key key-blue" depressed @click="subNum">
          <v-icon size="18">mdi-backspace-outline</v-icon>
        </v-btn>
        <v-btn class="key key-light" depressed @click="clickNum(200)">.</v-btn>
        <v-btn class="key key-blue" depressed @click="cancel">
          <v-icon size="18">mdi-language-c</v-icon>
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Numpad",
  props: {
    input: {
      type: [String, Number],
      default: "0",
    },
    label: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: "",
    },
    needSeperator: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: "0",
      previousValue: "0",
      replaceNext: true,
    };
  },
  watch: {
    input(val) {
      if (val != null && val != 0) {
        this.value = val.toString();
        this.previousValue = val.toString();
        this.replaceNext = true;
      } else {
        this.value = 0;
        this.previousValue = 0;
      }
    },
  },
  mounted() {
    if (this.input) {
      this.value = this.input.toString();
      this.previousValue = this.input.toString();
    }
  },
  methods: {
    subNum() {
      if (this.value.length > 1) {
        this.value = this.value.slice(0, -1);
      } else {
        this.value = "0";
      }
      this.$emit("save", this.value);
    },
    clickNum(num) {
      let n = num;

      if (this.value.length > 15) return;

      if (num === 10) n = "00";
      if (num === 100) n = "000";
      if (num === 200) n = ".";

      if (this.replaceNext) {
        this.value = n.toString();
        this.replaceNext = false;
        this.$emit("save", this.value);
        return;
      }

      if (this.value === "0") this.value = "";
      this.value += n.toString();

      this.$emit("save", this.value);
    },
    clickClear() {
      this.value = "0";
    },
    clickDecimal() {
      if (this.value.includes(".")) return;
      this.value = this.value + ".";
    },
    cancel() {
      this.clickClear();
      this.$emit("save", this.value);
    },
  },
};
</script>

<style scoped>
.numpad-title {
  font-size: 10.5pt !important;
}

.numpad-box {
  border-radius: 8px;
  background-color: #fff;
  padding: 0px;
}

.input-numpad {
  min-height: 50px;
  width: 100%;
  background: #f5f5f5;
  text-align: center;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px 10px;
}

.input-numpad-value {
  font-size: 22px;
  font-weight: 700;
  color: #2f3742;
  direction: ltr;
  unicode-bidi: plaintext;
}

.numpad-keypad {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 8px;
  direction: ltr;
}

.key {
  min-height: 48px !important;
  height: 48px !important;
  border-radius: 4px !important;
  font-size: 17px !important;
  font-weight: 700 !important;
  color: #2f3742 !important;
  box-shadow: none !important;
}

.key-light {
  background: #f5f5f5 !important;
}
.key-blue {
  background: #1976d2 !important;
  color: #f5f5f5 !important;
}

.key-small {
  font-size: 15px !important;
}
</style>
